import type { TOC } from '@ember/component/template-only';

import DataManagerConnectedDatasetsEditComponent from 'webapp/components/data-manager/connected/datasets/edit';

interface Args {
	controller: { model: string | null };
}

const DatamanagerConnectedDatasetsEditRouteTemplate: TOC<Args> = <template>
	<DataManagerConnectedDatasetsEditComponent @model={{@controller.model}} />
</template>;

export default DatamanagerConnectedDatasetsEditRouteTemplate;
